import type { Integration } from '@src/service/model'

import Repository from './base'

export class IntegrationRepository extends Repository<Integration> {
  othersForPhoneNumber(excludeIds: string[], phoneNumberId: string) {
    return this.table
      .where('id')
      .noneOf(excludeIds)
      .filter(
        (i) =>
          (i.type === 'slack' || i.type === 'email') && i.phoneNumberId === phoneNumberId,
      )
      .toArray()
  }
}
